<template>
  <ProductDetailTabs :config="config" :shopConfig="shopConfig" />
</template>

<script>
import setPublicPath from "../../utils/publicPath.js";
setPublicPath();

export default {
  name: "app",
  components: {
    ProductDetailTabs: () =>
      import(/* webpackChunkName: "chunk-product-detail-tab" */ "../../components/ProductDetailTabs/ProductDetailTabs.vue")
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config),
      shopConfig: JSON.parse(this.$options._parentVnode.data.props.shopConfig)
    };
  }
};
</script>
